import React, {useState} from "react"
import {FormattedMessage} from "react-intl"

const UseShowAdvancedToggle = () => {
    const [showAdvanced, setShowAdvanced] = useState(false)

    return {
        toggleContent:
            <a href={"#"} onClick={() => setShowAdvanced(!showAdvanced)}>
                {showAdvanced ?
                    <FormattedMessage
                        id={"common.hooks.use_hide_advanced_toggle.hide"}
                        defaultMessage={"Hide Advanced"}/> :
                    <FormattedMessage
                        id={"common.hooks.use_show_advanced_toggle.show"}
                        defaultMessage={"Show Advanced"}
                    />
                }
            </a>,
        toggleCurrent: showAdvanced
    }
}

export default UseShowAdvancedToggle


// WEBPACK FOOTER //
// ./src/common/hooks/UseShowAdvancedToggle.tsx